import { render, staticRenderFns } from "./ArrematanteExtra.vue?vue&type=template&id=cf85f27c"
import script from "./ArrematanteExtra.vue?vue&type=script&lang=js"
export * from "./ArrematanteExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports